// extracted by mini-css-extract-plugin
export var block = "section-dropdown-module--block--56482";
export var container = "section-dropdown-module--container--95464";
export var heading = "section-dropdown-module--heading--8ec35";
export var open = "section-dropdown-module--open--0d9b0";
export var section = "section-dropdown-module--section--280bb";
export var title = "section-dropdown-module--title--fc4ba";